module.exports = __webpack_public_path__ + "img/blockchain.e3a5ab76.jpg";